import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import videojs from 'video.js';
import { SeriesService } from 'src/app/Core/services/series.service';
import { Location } from '@angular/common';
// import   from 'videojs-seek-buttons'

// import ShareButton from '../sharebutton';
import BigPlayButton from '../bigplaybutton';
import ShareOverlay from '../shareoverlays'
import { UtilService } from 'src/app/Core/services/util.service';
declare var $: any;
// videojs.registerComponent('ShareButton', ShareButton);
videojs.registerComponent('BigPlayButton', BigPlayButton);
// videojs.registerComponent('ShareOverlay', ShareOverlay);

@Component({
  selector: 'app-seriesplayer',
  templateUrl: './seriesplayer.component.html',
  styleUrls: ['./seriesplayer.component.css']
})


export class SeriesplayerComponent implements OnInit, OnDestroy {
  id: string;
  id2: string;
  seriesinfo: any;
  stream_Url: any;
  currentUrl: any;
  videoUrl: any;
  isVideoOpened: boolean;
  seriesId: any;
  remainingTimeThreshold = 10
  videoTitle: any
  titles: string
  isPlaying: boolean = false;
  currentEpisodeId: any;
  player: any;
  titleSpan: any
  playerElement: any
  titleBarContainer: any
  currentIndex: any
  showModal: boolean = false;
  modalTitle: string = 'Error';
  OToken:any;
  url:any;
  constructor(private elRef:ElementRef,private router: Router,
    private route: ActivatedRoute, private seriesService: SeriesService, private location: Location,private utilService:UtilService) { 
    this.OToken = this.utilService.getOneStreamToken();

    }
    
    ngOnInit(): void {
      // const navigation = this.router.getCurrentNavigation();
      // const state = navigation?.extras.state as { link?: string };
      // console.log(state);
      const state = window.history.state as { link: string; container_extension: string };
      
      this.id2 = state?.container_extension;
      this.url = state?.link;
      console.log(state,'urls',this.id2,this.url);
      // if(){

      // }
      this.id = this.route.snapshot.params['id'];
      // this.id2 = this.route.snapshot.params['id2'];
      // this.videoTitle = this.route.snapshot.params['title']
      if (this.id && this.id2 && !this.OToken) {
        console.log(this.id, this.id2, 'ids');
        this.stream_Url = this.seriesService.getStreamSeriesUrl(this.id, this.id2);
        this.playSeries();
      } else if(this.OToken){
        this.stream_Url = this.url;
        this.playSeries();
      }
      this.seriesId = localStorage.getItem('seriesData')
      this.seriesId = JSON.parse(this.seriesId)
      console.log(this.seriesId, 'series ids....');
      this.getSeriesData()
    }
    
    
    
    ngAfterViewInit(): void {
      require('videojs-seek-buttons');
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
      // this.playSeries();
      // this.addKeyPressEvent();
      // this.getSeriesData();
      
    }
    
    getSeriesData() {
      this.seriesId.forEach((element, index) => {
        if (element.id == this.id) {
          this.titles = element.title
          this.currentIndex = index;
        // this.playNextEpisode()
        
      }
      
    });
    
  }
  playNextEpisode() {
    this.currentEpisodeId = this.id;
    let nextEpisodeId = null;
    let nextExtension = null;
    this.currentIndex = this.currentIndex + 1;

    console.log(this.currentEpisodeId, 'currnt id', this.seriesId.length, 'index', this.currentIndex);
    for (var i = this.currentIndex; i <= this.seriesId.length; i++) {
      this.seriesId.forEach((element, index) => {
        if (this.currentIndex === index) {
          nextEpisodeId = element.id;
          nextExtension = element.container_extension;
          this.titles = element.title
          console.log(this.titles, 'titles');
          if(this.OToken){
            const link = element.links.mp4 ? element.links.mp4 : element.links.mkv;
            this.url = link;
          }
        }
      });
      if (nextEpisodeId == null && nextExtension == null) {
        // this.player.dispose()
        this.location.back();
        // this.router.navigate([`/series/watch/${this.id}`])
      }
      // this.currentIndex++;
      console.log(nextEpisodeId, nextExtension, this.currentIndex, this.titles, 'id extensions...');
      break
    }
    
    
    // for (let i = this.currentIndex; i < this.seriesId.length; i++) {
      //   console.log(this.seriesId.length,'looping');
      
      //   if (this.seriesId[i].id > this.currentEpisodeId) {
        //     console.log(this.seriesId[i],'iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii');
        //     this.currentEpisodeId = this.currentEpisodeId + 1;
        //     nextEpisodeId = this.seriesId[i].id++;
        //     nextExtension = this.seriesId[i].container_extension;
        //     this.videoTitle = this.seriesId[i].title
        //     console.log(nextEpisodeId,nextExtension,this.videoTitle,'next id or extension');
        
        //     break;
        //   }else{
          //     nextEpisodeId = this.seriesId[i].id;
          //     nextExtension = this.seriesId[i].container_extension;
          //   }
          // }
          
          // If next episode ID is found, play it
          if (nextEpisodeId !== null) {
        // const nextEpisode = this.seriesId.find((episode: any) => episode.id === nextEpisodeId);
        if(this.OToken){
          this.stream_Url= this.url;
        }else{
          

          this.stream_Url = this.seriesService.getStreamSeriesUrl(nextEpisodeId, nextExtension);
          this.titles = this.titles
          console.log(this.stream_Url, 'url', this.titles);
        }
      
      videojs("example-videoplay", {
        controls: true, // enable controls
        autoplay: true, // enable autoplay
        preload: "auto", // preload video
        muted: false
      }).src([{ type: "video/mp4", src: this.stream_Url }]);
    }
  }

  
  playSeries() {
    // this.addKeyPressEvent()
    // this.stream_Url = this.seriesService.getStreamSeriesUrl(this.id, this.id2);
    setTimeout(() => {
      // videojs("example-videoplay").src([
        //   { type: "video/mp4", src: this.stream_Url },
        // ]);
        // var player = videojs('example-videoplay');
        // player.on('ended', function () {  
          // this.dispose();
          // window.history.back()
          // });
          console.log(this.stream_Url, 'url');
          // videojs.registerComponent('ShareOverlay', ShareOverlay);
          videojs("example-videoplay", {
            controls: true, // enable controls
            autoplay: false, // enable autoplay
            preload: "auto", // preload videoShareOverlay
            muted: false
      }).src([
        { type: "video/mp4", src: this.stream_Url }
      ]);
      
      this.player = videojs('example-videoplay');
      this.player.seekButtons({
        back: 10,
        forward: 10
      });
      const Button = videojs.getComponent('Button');
      // this.player.getChild('controlBar').addChild('ShareButton',);
      // this.player.addChild('ShareOverlay', this.player.options);
      
      

      this.player.on('play', () => {
        this.player.removeChild('BigPlayButton')

        this.addTitleBar()
        // this.showModal = false;
        this.player.addTitleBar.update('mahadev ji ')
      })


      this.player.on('ended', () => {
        this.playNextEpisode()
        console.log("next play");
        
        // Disposing the player to clean up resources
        // player.dispose();
        // this.playSeriesNext();
        // const nextEpisode = this.seriesId.find((episode) => episode.id );
        // console.log(nextEpisode,'next episodes');

        // Go back in browser history when video ends
        // window.history.back();
      });

      this.player.on('timeupdate', () => {
        const remainingTime = this.player.duration() - this.player.currentTime();
        if (remainingTime <= this.remainingTimeThreshold) {
          // this.playSeriesNext()
          // this.playNextEpisode()
          // this.getSeriesData()

        }
      })

      this.player.on('pause', () => {
        this.player.addChild('BigPlayButton')

        // var ModalDialog = videojs.getComponent('ModalDialog');
        // var modal = new ModalDialog(this.player, {
        //   temporary: false
        // });
        // this.player.addChild(modal);
      })



      this.player.on('mouseenter', () => {
        this.addTitleBar()

      })
      this.player.on('mouseleave', () => {
        //  this.addTitleBar()

      })

      this.player.on('error', () => {
        this.player.removeChild('BigPlayButton')

        // var modal = this.player.createModal('This is a modal!');

        // this.player.on('play', function() {
        //   modal.close();
        // });
        // this.addTitleBar();
        // this.playerElement = this.player.el();
        // Create title bar container directly within the player element
        // this.titleBarContainer = document.createElement('div');
        // this.titleBarContainer.classList.add('vjs-error-display');
        // this.titleSpan.style.fontSize = '20px';
        // this.titleSpan.style.position = 'absolute';
        // this.titleSpan.style.top = '3rem';
        // this.titleSpan.style.left = '0';
        // this.titleSpan.style.width = '100%';
        // this.titleSpan.style.zIndex = '99';
        // this.titleSpan.style.display ='flex';
        // this.titleSpan.style.height ='50px';
        // this.titleSpan.style.margin='5rem 0 0 0 ';
        // this.titleSpan.style.alignItems = 'center';
        // this.titleSpan.style.justifyContent = 'center';
        // this.titleSpan.style.background = 'red';
        // this.titleSpan.textContent = 'error during playing ';
        // this.titleSpan.content  = ' ';
        // this.titleBarContainer.appendChild(this.titleSpan);
        // this.playerElement.insertBefore(this.titleBarContainer, this.playerElement.element);
        this.showModal = true;
        this.modalTitle = 'Error - Video Paused';
        setTimeout(() => {
          // this.playNextEpisode()
        }, 1000);
      })


      // var myButton = player.controlBar.addChild("button");

      // There are many functions available for button component 
      // like below mentioned in this docs 
      // https://docs.videojs.com/button. 
      // You can set attributes and clasess as well.

      // Getting html DOM
      // var myButtonDom = myButton.el();
      // Since now you have the html dom element 
      // you can add click events

      // Now I am setting the text as you needed.
      // myButtonDom.innerHTML = "EXIT";

      // myButtonDom.onclick = function () {
      //   window.location.href = "/series"
      // }
    }, 1000
  );

  }

  closePlayNext() {
    this.showModal = false
    this.playNextEpisode()
  }
  closeModal() {
    this.showModal = false
  }

  addTitleBar() {
    this.removeTitleBar();
    this.playerElement = this.player.el();
    // Create title bar container directly within the player element
    this.titleBarContainer = document.createElement('div');
    this.titleBarContainer.classList.add('videojs-title-bar'); // Add CSS class
    // Optionally set title content here (or dynamically later)
    this.titleSpan = document.createElement('span');
    this.titleSpan.style.fontSize = '20px';
    this.titleSpan.style.position = 'absolute';
    this.titleSpan.style.top = '3rem';
    this.titleSpan.style.left = '0';
    this.titleSpan.style.width = '100%';
    this.titleSpan.style.zIndex = '99';
    this.titleSpan.style.display = 'flex';
    this.titleSpan.style.height = '50px';
    this.titleSpan.style.alignItems = 'center';
    this.titleSpan.style.justifyContent = 'center';
    this.titleSpan.style.background = 'rgb(12 0 0 / 10%)';
    this.titleSpan.style.userSelect = 'none';
    this.titleSpan.style.display = '{ isPlaying ? "none" : "block"}'
    this.titleSpan.textContent = this.titles;
    this.titleBarContainer.appendChild(this.titleSpan);
    this.playerElement.insertBefore(this.titleBarContainer, this.playerElement.element);
    console.log(this.titleSpan, this.titleBarContainer, this.playerElement.firstChild, 'titles');

    this.disableTitle()
  }
  disableTitle() {
    setTimeout(() => {
      this.titleSpan.style.display = 'none';
    }, 5000);

  }

  removeTitleBar() {
    // Remove any existing title bars
    if (this.titleBarContainer && this.titleBarContainer.parentNode) {
      this.titleBarContainer.parentNode.removeChild(this.titleBarContainer);
    }
  }



  backToInfo() {
    this.location.back();
    // const previousPage = localStorage.getItem('previousPage');
    // if (previousPage) {
    //   localStorage.removeItem('previousPage');
    //   window.location.href = previousPage;
    // } else {
    //  this.router.navigate(['/series'])
    // }
  }
  addKeyPressEvent() {
    // Add keypress event listener
    this.elRef.nativeElement.addEventListener('keypress', (event) => {
      if (event.keyCode === 32) {
        this.togglePlayPause();  
      }
    });
  }
  togglePlayPause(){
    if(this.player.paused()){
      this.player.play()
    }else{
      this.player.paused()
    }
  }

  ngOnDestroy(): void {
    this.player = videojs('example-videoplay');
    this.player.dispose()
    // this.player.removeChild('BigPlayButton')
    if (document.pictureInPictureEnabled && document.exitPictureInPicture) {
      document.exitPictureInPicture();
    } else {
      console.log('Picture-in-Picture mode or exitPictureInPicture() not supported.');
    }


  }





}
